import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js';

const PHONE_REGEXP = new RegExp('[0-9]{5,}', 'i');

/**
 * validates a phone number
 * @param phone - phone number to validate
 * @param strict - strict validation will validate the phone number as an international phone number with country code (e.g. +12133734253)
 * @returns whether the phone number is valid
 */
export function isValidPhone(phone: string | number, strict = false): boolean {
  if (strict) {
    try {
      return isValidPhoneNumber(phone.toString());
    } catch {
      return false;
    }
  }

  const phoneString = phone.toString();
  return !!phoneString.match(PHONE_REGEXP);
}

export function validatePhone(
  control: AbstractControl,
  strict = false
): ValidationErrors | null {
  return !control.value || isValidPhone(control.value, strict)
    ? null
    : { phone: 'Invalid Phone' };
}

@Directive({
  selector: '[elmValidatePhone]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ElmValidatePhoneDirective,
      multi: true
    }
  ]
})
export class ElmValidatePhoneDirective implements Validator {
  @Input('elmValidatePhone') strict = false;

  validate(control: AbstractControl): ValidationErrors | null {
    return validatePhone(control, this.strict);
  }
}
